import React, { useState, useEffect } from "react";
import "./Inventory.css";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useLocation } from "react-router-dom";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Dropdown from "react-bootstrap/Dropdown";
import { TbFileExport } from "react-icons/tb";
import Modal from "react-bootstrap/Modal";
import { MdDeleteOutline } from "react-icons/md";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import { Formik, useFormik } from "formik";
import TablePagination from "@mui/material/TablePagination";
import { AiOutlineDelete } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { IoClose } from "react-icons/io5";

function createData4(
  productCode,
  productName,
  category,
  uom,
  currentStock,
  minimum,
  defaultCost,
  totalCost,
) {
  return {
    productCode,
    productName,
    category,
    uom,
    currentStock,
    minimum,
    defaultCost,
    totalCost,
  };
}

const rows4 = [
  createData4(
    "001",
    "Enamel white",
    "Emulsion",
    "10L",
    "200",
    "500",
    "₹400",
    "₹4,80,000",
  ),
];
export const InventoryView = () => {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const { Id, productCode } = location.state || "";
  console.log("ID", Id);
  console.log("productCode", productCode);
  const [previews, setPreviews] = useState({
    product_image: null,
  });
  const [refNo, setRefNo] = useState();
  const [receivedData, setReceivedData] = useState();
  const [additionalNote, setAdditionalNote] = useState();
  const [productDetails, setProductDetails] = useState({});
  const [stockDetails, setStockDetails] = useState({});

  // add incoming stock modal
  const [addshow, setAddShow] = useState(false);

  const handleAddClose = () => setAddShow(false);
  const handleAddShow = () => setAddShow(true);
  //   reorder modal
  const [reordershow, setReorderShow] = useState(false);

  const handleReorderClose = () => setReorderShow(false);
  const handleReorderShow = () => setReorderShow(true);
  // edit product modal
  const [editshow, setEditShow] = useState(false);

  const handleEditClose = () => setEditShow(false);
  const handleEditShow = () => {
    setEditShow(true);
    // LoadSingleProduct(productCode);
  };

  // in stock history edit modal
  const [inStockEditId, setInStockEditId] = useState("");
  const [instockeditshow, setInstockEditShow] = useState(false);

  const handleInstockEditClose = () => setInstockEditShow(false);
  const handleInstockEditShow = (id, existingQty) => {
    setInstockEditShow(true);
    setInStockEditId(id);
    setInStockQty(existingQty);
  };
  const [instockQty, setInStockQty] = useState("");
  async function handleInStockEdit() {
    try {
      setLoading(true);
      const payload = {
        qty: instockQty,
      };
      const response = await axiosInstance.put(
        `/inventory/distributor/incoming-stock-item-single-update/${inStockEditId}/`,
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Updated successfully!");
        handleInstockEditClose();
        FetchStockInHistory();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to update");
      console.log("Failed to update");
    } finally {
      setLoading(false);
    }
  }

  // delete instock history
  const [deleteStockId, setDeleteStockId] = useState();
  const [deleteStockshow, setDeleteStockShow] = useState(false);

  const handleDeleteStockClose = () => setDeleteStockShow(false);
  const handleDeleteStockShow = (id) => {
    setDeleteStockShow(true);
    setDeleteStockId(id);
  };

  async function handleDeleteStockIn() {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `inventory/distributor/incoming-stock-item-single-update/${deleteStockId}/`,
      );
      if (response.data.status === "Success" || response.status === 200) {
        toast.success(response.data.message || "Deleted successfully");
        handleDeleteStockClose();
        FetchStockInHistory();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed to delete");
      console.log("Failed to delete");
    } finally {
      setLoading(false);
    }
  }

  async function fetchProductDetails(Id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`inventory/product/${Id}`);
      if (response.data.status === "success" || response.status === 200) {
        setProductDetails(response.data.data);

        console.log(
          response.data.message || "Product details fetched successfully",
        );
        // toast.success(
        //   response.data.message || "Product details fetched successfully"
        // );
      }
    } catch (error) {
      console.log("Failed to fetch product details", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch product details",
      );
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchProductDetails(Id);
  }, []);
  const [total, setTotal] = useState();
  const [qty, setQty] = useState(); // to display in Total Products Received
  function handleQtyChange(value, defaultCost) {
    const qtyValue = Number(value);
    setQty(qtyValue);
    setTotal(qtyValue * Number(defaultCost || 0));
  }

  async function handleSave() {
    try {
      setLoading(true);

      const payload = {
        reference_no: refNo?.trim() || "",
        received_date: receivedData,
        additional_notes: additionalNote,
        products: [
          {
            product_id: productDetails.id,
            qty: qty,
            unit_cost_price: productDetails.default_cost_price || 0,
            total_cost: total,
          },
        ],
      };
      console.log("payload", payload);
      const response = await axiosInstance.post(
        "/inventory/distributor/incoming-stock/",
        payload,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setRefNo("");
        setReceivedData("");
        setAdditionalNote("");
        setQty("");
        setTotal("");
        handleAddClose();
        toast.success(response.data.message || "submitted successfully");
        console.log("submitted successfully");
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit");
      console.log("Failed to submit");
    } finally {
      setLoading(false);
    }
  }
  // edit
  const editformik = useFormik({
    initialValues: {
      product_image: null,
      product_name: "",
      product_code: "",
      category: "",
      uom: "",
      default_cost_price: "",
      subdistributor_selling_price: "",
      retail_selling_price: "",
      min_stock_level: "",
      isi_code: "",
      package_size: "",
      hs_code: "",
      additional_notes: "",
    },
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        const formData = new FormData();
        // formData.append("product_image", values.product_image);
        // only send new file
        if (values.product_image instanceof File) {
          formData.append("product_image", values.product_image);
        }
        formData.append("product_name", values.product_name);
        formData.append("product_code", values.product_code);
        formData.append("category", values.category);
        formData.append("uom", values.uom);
        formData.append("default_cost_price", values.default_cost_price);
        formData.append(
          "subdistributor_selling_price",
          values.subdistributor_selling_price,
        );
        formData.append("retail_selling_price", values.retail_selling_price);
        formData.append("min_stock_level", values.min_stock_level);
        formData.append("isi_code", values.isi_code);
        formData.append("package_size", values.package_size);
        formData.append("hs_code", values.hs_code);
        formData.append("additional_notes", values.additional_notes);

        const response = await axiosInstance.patch(
          `inventory/product/${productCode}/`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response.data.status === "success" || response.status === 200) {
          toast.success(response.data.message || "Product edited successfully");
          resetForm();
          handleEditClose();
        }
      } catch (error) {
        toast.error("Failed to edit product");
        console.log("Failed to edit product");
      } finally {
        setLoading(false);
      }
    },
  });
  // edit single product get
  async function LoadSingleProduct(Id) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/inventory/product/${Id}/`);
      if (response.data.status === "success" || response.status === 200) {
        editformik.setValues(response.data.data);
        setPreviews({
          product_image: response.data.data.product_image || null,
        });
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load product data");
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (Id) {
      LoadSingleProduct(Id);
    }
  }, []);
  const [categoryDropdown, setCategoryDropdown] = useState([]);

  async function LoadCategoryDropdown() {
    try {
      setLoading(true);
      const response = await axiosInstance.get("/inventory/category/");
      if (response.data.status === "Success" || response.status === 200) {
        setCategoryDropdown(response.data.data);
        console.log("category dropdown fetched successfully");
      }
    } catch (error) {
      toast.error(
        error.response.data.message || "Failed to fetch category dropdown",
      );
      console.log("Failed to fetch category dropdown");
    }
  }
  useEffect(() => {
    LoadCategoryDropdown();
  }, []);
  // fetch stock details (cards)
  async function FetchStockDetailes() {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `/inventory/distributor/product-get/${Id}/`,
      );

      if (response.data.status === "success" || response.status === 200) {
        setStockDetails(response.data.data);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch Stock Details products",
      );
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    FetchStockDetailes();
  }, []);

  const [stockInHistory, setStockInHistory] = useState({});
  const [stockInPage, setStockInPage] = useState(0);
  const [stockInRowsPerPage, setStockInRowsPerPage] = useState(5);
  const [stockInTotalCount, setStockInTotalCount] = useState(0);
  const [inStockDateFilter, setInStockDateFilter] = useState("");

  const handleInStockRowsPerPage = (event) => {
    setStockInRowsPerPage(+event.target.value);
    setStockInPage(0);
  };
  async function FetchStockInHistory() {
    try {
      setLoading(true);
      const config = {
        params: {
          page: stockInPage + 1, // backend expects 1-based index
          page_size: stockInRowsPerPage,
          date: inStockDateFilter,
        },
      };
      const response = await axiosInstance.get(
        `/inventory/distributor/product-instock-history/${Id}/`,
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setStockInHistory(response.data.data);
        setStockInTotalCount(response.data?.data.count);
      }
    } catch (error) {
      toast.error(
        error.response.data.message ||
          "Failed to fetch Stock In History products",
      );
      console.log("Failed to fetch Stock In History products");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    FetchStockInHistory();
  }, [stockInPage, stockInRowsPerPage, inStockDateFilter]);

  function handleClearInStockFilters() {
    setInStockDateFilter("");
  }

  const [stockOutHistory, setStockOutHistory] = useState([]);
  const [outStockDateFilter, setOutStockDateFilter] = useState("");
  const [outStockSort, setOutStockSort] = useState("");

  async function FetchStockOutHistory() {
    try {
      setLoading(true);
      const config = {
        params: {
          date: outStockDateFilter,
          sort_by: outStockSort,
        },
      };
      const response = await axiosInstance.get(
        `/inventory/distributor/product-outstock-history/${Id}/`,
        config,
      );
      if (response.data.status === "Success" || response.status === 200) {
        setStockOutHistory(response.data.data);
      }
    } catch (error) {
      toast.error(
        error.response.data.message ||
          "Failed to fetch Stock Out History products",
      );
      console.log("Failed to fetch Stock Out History products");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    FetchStockOutHistory();
  }, [outStockDateFilter, outStockSort]);

  function handleClearOutStockFilters() {
    setOutStockDateFilter("");
    setOutStockSort("");
  }

  function formatDate(date) {
    if (!date) return "--";
    const d = new Date(date);
    return d.toLocaleDateString("en-GB");
  }
  async function handleStockInExport() {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        `/inventory/distributor/instock-excel/${Id}/`,
        {
          responseType: "blob", // Required
        },
      );

      if (response.status === 200) {
        // const blob = new Blob([response.data], { type: "application/pdf" });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        // const contentDisposition = response.headers["content-disposition"];
        // let fileName = "invoice.pdf";
        // // let fileName;
        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?(.+)"?/);
        //   if (match && match[1]) fileName = match[1];
        // }

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "stock_in.xlsx";

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            fileName = match[1].endsWith(".xlsx")
              ? match[1]
              : `${match[1]}.xlsx`;
          }
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      // toast.error(error?.response?.data?.message || "Unable to download");

      // console.error("Download error:", error);
      let errorMessage = "Unable to download";

      if (error.response && error.response.data) {
        const data = error.response.data;

        if (data instanceof Blob) {
          // If backend sent JSON in blob (common for errors)
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const json = JSON.parse(reader.result);
              toast.error(json.message || errorMessage);
            } catch {
              toast.error(errorMessage);
            }
          };
          reader.readAsText(data);
        } else if (data.message) {
          toast.error(data.message);
        } else {
          toast.error(errorMessage);
        }
      } else {
        toast.error(errorMessage);
      }

      console.error("Download error:", error);
    } finally {
      setLoading(false);
    }
  }
  async function handleStockOutExport() {
    try {
      setLoading(true);

      const response = await axiosInstance.get(
        `/inventory/distributor/outstock-excel/${Id}/`,
        {
          responseType: "blob", // Required
        },
      );

      if (response.status === 200) {
        // const blob = new Blob([response.data], { type: "application/pdf" });
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        // Try server-provided filename
        // const contentDisposition = response.headers["content-disposition"];
        // let fileName = "invoice.pdf";
        // // let fileName;
        // if (contentDisposition) {
        //   const match = contentDisposition.match(/filename="?(.+)"?/);
        //   if (match && match[1]) fileName = match[1];
        // }

        const contentDisposition = response.headers["content-disposition"];
        let fileName = "stock_out.xlsx";

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="?(.+)"?/);
          if (match && match[1]) {
            fileName = match[1].endsWith(".xlsx")
              ? match[1]
              : `${match[1]}.xlsx`;
          }
        }

        // Trigger download
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      // toast.error(error?.response?.data?.message || "Unable to download");

      // console.error("Download error:", error);
      let errorMessage = "Unable to download";

      if (error.response && error.response.data) {
        const data = error.response.data;

        if (data instanceof Blob) {
          // If backend sent JSON in blob (common for errors)
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const json = JSON.parse(reader.result);
              toast.error(json.message || errorMessage);
            } catch {
              toast.error(errorMessage);
            }
          };
          reader.readAsText(data);
        } else if (data.message) {
          toast.error(data.message);
        } else {
          toast.error(errorMessage);
        }
      } else {
        toast.error(errorMessage);
      }

      console.error("Download error:", error);
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />
      <div className="inventoryContainer">
        <div className="container">
          <div className="viewInventoryTitleContainer">
            <div>
              <div className="inventoryTitle">
                <span className="me-2">
                  <Link to="/state-inventory" style={{ color: "black" }}>
                    <FaArrowLeftLong />
                  </Link>
                </span>
                Premium Interior Emulsion
              </div>
              <div className="inventorySubtitle">
                SKU: PNT-001 | Category: Emulsion | UOM: 20L
              </div>
            </div>
            <div className="addButtonContainer">
              <div className="inventoryBtnPro">
                <button onClick={handleEditShow}>Edit Product</button>
              </div>
              <div className="inventoryBtnReorder">
                <button onClick={handleReorderShow}>Re-Order</button>
              </div>

              <div className="inventoryBtnIncome">
                <button onClick={handleAddShow}>Add Incoming Stock</button>
              </div>
            </div>
          </div>
          {/* cards part  */}
          <div className="viewInventoryCardGrid">
            <div className="inventoryCard">
              <div>Current Stock</div>
              <div>{stockDetails.current_stock ?? "--"}</div>
            </div>
            <div className="inventoryCard">
              <div>Last Received</div>
              <div>
                {formatDate(stockDetails.last_received_date)}{" "}
                {stockDetails.last_received_qty
                  ? `(${stockDetails.last_received_qty})`
                  : ""}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Sub-Distributor Price</div>
              <div>
                {stockDetails.sub_distributor_price
                  ? `₹${stockDetails.sub_distributor_price}`
                  : "--"}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Retail Price</div>
              <div>
                {stockDetails.retail_price
                  ? `₹${stockDetails.retail_price}`
                  : "--"}
              </div>
            </div>
            <div className="inventoryCard">
              <div>Min Stock Level</div>
              <div>{stockDetails.min_stock_level ?? "--"}</div>
            </div>
          </div>

          {/* stock In history table  */}
          <div className="inventoryFilterContainer">
            <div className="titleOrderList">Stock In History</div>

            <div className="inventoryFilters">
              <div className="inventoryBtnExport">
                <button onClick={handleStockInExport}>
                  Export{" "}
                  <span>
                    <TbFileExport />
                  </span>
                </button>
              </div>
              {/* <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    Last 7 days
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}
              <div>
                <input
                  type="date"
                  className="dateInput"
                  value={inStockDateFilter}
                  onChange={(e) => setInStockDateFilter(e.target.value)}
                />
              </div>
            </div>
          </div>

          {inStockDateFilter && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {inStockDateFilter && (
                  <>
                    {" "}
                    &nbsp; <strong>Date:</strong> {inStockDateFilter}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearInStockFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell align="left">Reference No.</TableCell>
                    <TableCell align="left">Previous Stock</TableCell>
                    <TableCell align="left">Qty Received</TableCell>
                    <TableCell align="left">Total Stock</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {stockInHistory?.results?.length > 0 ? (
                    stockInHistory?.results?.map((row, index) => (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell>{row.received_date || "—"}</TableCell>
                        <TableCell>{row.reference_no || "—"}</TableCell>
                        <TableCell>{row.previous_stock ?? "—"}</TableCell>
                        <TableCell>{row.qty_received ?? "—"}</TableCell>
                        <TableCell>{row.total_stock ?? "—"}</TableCell>
                        {/* Actions */}
                        <TableCell align="left">
                          <div className="d-flex gap-3">
                            <span
                              onClick={() =>
                                handleInstockEditShow(row.id, row.qty_received)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              <FiEdit />
                            </span>
                            <span onClick={() => handleDeleteStockShow(row.id)}>
                              <AiOutlineDelete />
                            </span>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={5} align="center">
                        {loading ? "Loading..." : "No Data Available"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
            <TablePagination
              component="div"
              count={stockInTotalCount}
              page={stockInPage}
              onPageChange={(event, newPage) => setStockInPage(newPage)}
              rowsPerPage={stockInRowsPerPage}
              onRowsPerPageChange={handleInStockRowsPerPage}
              rowsPerPageOptions={[5, 10, 20, 50]}
            />
          </div>

          {/* stock out history table  */}
          <div className="inventoryFilterContainer">
            <div className="titleOrderList">Stock Out History</div>

            <div className="inventoryFilters">
              <div className="inventoryBtnExport">
                <button onClick={handleStockOutExport}>
                  Export{" "}
                  <span>
                    <TbFileExport />
                  </span>
                </button>
              </div>
              <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    {outStockSort || "Sort By"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => setOutStockSort("qty_sold")}>
                      Qty Sold
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              {/* <div>
                <Dropdown>
                  <Dropdown.Toggle
                    className="btnDropdownProduct"
                    id="dropdown-basic"
                  >
                    Last 7 days
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                    <Dropdown.Item>---</Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div> */}
              <div>
                <input
                  type="date"
                  className="dateInput"
                  value={outStockDateFilter}
                  onChange={(e) => setOutStockDateFilter(e.target.value)}
                />
              </div>
            </div>
          </div>
          {(outStockDateFilter || outStockSort) && (
            <div className="filterResultsContainer">
              <div>
                <span style={{ color: "var(--color-font-primary)" }}>
                  Showing Results Of:
                </span>

                {outStockDateFilter && (
                  <>
                    {" "}
                    &nbsp; <strong>Date:</strong> {outStockDateFilter}{" "}
                  </>
                )}
                {outStockSort && outStockSort !== "Sort By" && (
                  <>
                    {" "}
                    &nbsp; <strong>Sort By:</strong> {outStockSort}{" "}
                  </>
                )}
              </div>

              <div
                style={{
                  cursor: "pointer",
                  color: "var(--color-font-primary)",
                }}
                onClick={handleClearOutStockFilters}
              >
                <span className="me-1">
                  <IoClose />
                </span>
                Clear Filters
              </div>
            </div>
          )}
          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table
                // sx={{ minWidth: 650 }}
                stickyHeader
                aria-label="sticky table"
              >
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell align="left">Ref/Invoice No.</TableCell>
                    <TableCell align="left">
                      Customer / Sub-Distributor
                    </TableCell>
                    <TableCell align="left">Previous Stock</TableCell>
                    <TableCell align="left">Qty Sold</TableCell>
                    <TableCell align="left">Remaining Stock</TableCell>
                    <TableCell align="left">Selling Price</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stockOutHistory?.length > 0 ? (
                    stockOutHistory?.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>{row.date ?? "—"}</TableCell>
                        <TableCell>{row.ref_or_invoice_no ?? "—"}</TableCell>
                        <TableCell>
                          {row.customer_or_subdistributor ?? "—"}
                        </TableCell>
                        <TableCell>{row.previous_stock ?? "—"}</TableCell>
                        <TableCell>{row.qty_sold ?? "—"}</TableCell>
                        <TableCell>{row.remaining_stock ?? "—"}</TableCell>
                        <TableCell>{row.selling_price ?? "—"}</TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={7} align="center">
                        {loading ? "Loading..." : "No Data Available"}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* add incoming stock modal  */}
          <div>
            <Modal
              show={addshow}
              onHide={handleAddClose}
              centered
              size="xl"
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Add Incoming Stock (Premium Interior Enamel-001)
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>Reference No.</label>
                    <input
                      type="text"
                      placeholder="Enter Reference No."
                      value={refNo}
                      onChange={(e) => setRefNo(e.target.value)}
                    />
                  </div>
                  <div>
                    <label>Received Date</label>
                    <input
                      type="date"
                      onChange={(e) => setReceivedData(e.target.value)}
                      value={receivedData}
                    />
                  </div>
                </div>
                <div className="dashboardTableContainer">
                  <TableContainer component={Paper}>
                    <Table
                      // sx={{ minWidth: 650 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead className="dashboadTableHeader">
                        <TableRow>
                          <TableCell>Product Code</TableCell>
                          <TableCell align="left">Product</TableCell>
                          <TableCell align="left">Category</TableCell>
                          <TableCell align="left">UOM</TableCell>
                          <TableCell align="left">Qty</TableCell>
                          <TableCell align="left">
                            Default Cost Price / Unit
                          </TableCell>
                          <TableCell align="left">Total Cost</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {productDetails &&
                        Object.keys(productDetails).length > 0 ? (
                          <TableRow
                            key={productDetails.id}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            className="dashboardTableBody"
                          >
                            <TableCell align="left">
                              {productDetails.product_code}
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.product_name}
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.category}
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.uom}
                            </TableCell>
                            <TableCell align="left">
                              <span className="addModalQtyInput">
                                <input
                                  type="text"
                                  value={qty}
                                  placeholder="Qty"
                                  onChange={(e) =>
                                    handleQtyChange(
                                      e.target.value,
                                      productDetails.default_cost_price,
                                    )
                                  }
                                />
                              </span>
                            </TableCell>
                            <TableCell align="left">
                              {productDetails.default_cost_price}
                            </TableCell>
                            <TableCell align="left">{total}</TableCell>
                          </TableRow>
                        ) : (
                          <TableRow>
                            <TableCell align="center" colSpan={7}>
                              No product details found
                            </TableCell>
                          </TableRow>
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="addModalTotalContainer">
                  <div>
                    <div className="addModalContent">
                      <span>Total Products Received(Qty):</span>
                      <span>{qty}</span>
                    </div>
                    <div className="addModalContent">
                      <span>Total Value:</span>
                      <span>{total}</span>
                    </div>
                  </div>
                </div>

                <div className="addModalTextGrid">
                  <div>
                    <label>Additional Notes</label>
                  </div>
                  <div>
                    <textarea
                      placeholder="Type here"
                      rows={4}
                      value={additionalNote}
                      onChange={(e) => setAdditionalNote(e.target.value)}
                    ></textarea>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button className="addBtnCancel" onClick={handleAddClose}>
                  Cancel
                </button>
                <button className="addBtnSave" onClick={handleSave}>
                  {" "}
                  Save & Add Stock
                </button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* reorder modal  */}
          <div>
            <Modal
              show={reordershow}
              onHide={handleReorderClose}
              centered
              size="xl"
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">
                  Re-Order Stock
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>Reference No.</label>
                    <input type="text" placeholder="Enter Reference No." />
                  </div>
                  <div>
                    <label>Received Date</label>
                    <input type="date" />
                  </div>
                </div>
                <div className="addModalGrid">
                  <div>
                    <label>Priority</label>
                    <select>
                      <option>Select</option>
                    </select>
                  </div>
                  <div>{""}</div>
                </div>
                <div className="dashboardTableContainer">
                  <TableContainer component={Paper}>
                    <Table
                      // sx={{ minWidth: 650 }}
                      stickyHeader
                      aria-label="sticky table"
                    >
                      <TableHead className="dashboadTableHeader">
                        <TableRow>
                          <TableCell>Product Code</TableCell>
                          <TableCell align="left">Product Name</TableCell>
                          <TableCell align="left">Category</TableCell>
                          <TableCell align="left">UOM</TableCell>
                          <TableCell align="left">Current Stock</TableCell>
                          <TableCell align="left">Minimum Stock</TableCell>
                          <TableCell align="left">Qty</TableCell>
                          <TableCell>Default Cost Price / Unit</TableCell>
                          <TableCell>Total Cost</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {rows4.map((row) => (
                          <TableRow
                            key={row.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                            className="dashboardTableBody"
                          >
                            <TableCell align="left">
                              {row.productCode}
                            </TableCell>
                            <TableCell align="left">
                              {row.productName}
                            </TableCell>
                            <TableCell align="left">{row.category}</TableCell>
                            <TableCell align="left">{row.uom}</TableCell>
                            <TableCell align="left">
                              {row.currentStock}
                            </TableCell>
                            <TableCell align="left">{row.minimum}</TableCell>

                            <TableCell align="left">
                              <span className="addModalQtyInput">
                                <input type="text" />
                              </span>
                            </TableCell>
                            <TableCell align="left">
                              {row.defaultCost}
                            </TableCell>
                            <TableCell align="left">{row.totalCost}</TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </div>

                <div className="addModalTotalContainer">
                  <div>
                    <div className="addModalContent">
                      <span>Total Requested Qty:</span>
                      <span>1200 nos</span>
                    </div>
                    <div className="addModalContent">
                      <span>Total Value:</span>
                      <span>₹4,80,000</span>
                    </div>
                  </div>
                </div>

                <div className="addModalTextGrid">
                  <div>
                    <label>Additional Notes</label>
                  </div>
                  <div>
                    <textarea placeholder="Type here" rows={4}></textarea>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button className="addBtnCancel" onClick={handleReorderClose}>
                  Cancel
                </button>
                <button className="addBtnSave" onClick={handleReorderClose}>
                  {" "}
                  Submit Request
                </button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* edit product modal  */}
          <div>
            <Modal
              show={editshow}
              onHide={handleEditClose}
              centered
              size="lg"
              className="addModal"
            >
              <form onSubmit={editformik.handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title className="addModalTitle">
                    Edit Product
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="addModalGrid">
                    <div>
                      <label>Product Image</label>
                      <input
                        type="file"
                        name="product_image"
                        onChange={(e) =>
                          editformik.setFieldValue(
                            "product_image",
                            e.currentTarget.files[0],
                          )
                        }
                      />

                      {/* image preview  */}
                      {previews.product_image && (
                        <img
                          src={previews.product_image}
                          alt="Preview"
                          className="mt-3"
                          style={{ width: "100px", objectFit: "contain" }}
                        />
                      )}
                    </div>
                    <div>{""}</div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>Product Name</label>
                      <input
                        type="text"
                        placeholder="Enter Product Name"
                        name="product_name"
                        value={editformik.values.product_name}
                        onChange={editformik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Product Code</label>
                      <input
                        type="text"
                        placeholder="Enter Product Code"
                        name="product_code"
                        value={editformik.values.product_code}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <div className="d-flex justify-content-between">
                        <label>Category</label>
                      </div>
                      <select
                        onChange={editformik.handleChange}
                        name="category"
                        value={editformik.values.category}
                      >
                        <option value={""}>Select Category</option>
                        {categoryDropdown.length > 0 ? (
                          categoryDropdown.map((cat) => (
                            <option value={cat.name}>{cat.name}</option>
                          ))
                        ) : (
                          <option>Data not available</option>
                        )}
                      </select>
                    </div>
                    <div>
                      <label>Min Stock Level</label>
                      <input
                        type="text"
                        placeholder="Enter min stock level"
                        name="min_stock_level"
                        value={editformik.values.min_stock_level}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>Default Cost Price (₹)</label>
                      <input
                        type="text"
                        placeholder="Enter Price"
                        name="default_cost_price"
                        value={editformik.values.default_cost_price}
                        onChange={editformik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Sub-distributor Selling Price</label>
                      <input
                        type="text"
                        placeholder="Enter Selling Price"
                        name="subdistributor_selling_price"
                        value={editformik.values.subdistributor_selling_price}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>Retail Selling Price</label>
                      <input
                        type="text"
                        placeholder="Enter Selling Price"
                        name="retail_selling_price"
                        value={editformik.values.retail_selling_price}
                        onChange={editformik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Unit of Measure</label>
                      <select
                        onChange={editformik.handleChange}
                        name="uom"
                        value={editformik.values.uom}
                      >
                        <option>Select UOM</option>
                        <option value={"lts"}>lts</option>
                        <option value={"kgs"}>kgs</option>
                        <option value={"grms"}>grms</option>
                      </select>
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>ISI Code</label>
                      <input
                        type="text"
                        placeholder="Enter ISI Code"
                        name="isi_code"
                        value={editformik.values.isi_code}
                        onChange={editformik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Package Size</label>
                      <input
                        type="text"
                        placeholder="Enter Package Size"
                        name="package_size"
                        value={editformik.values.package_size}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalGrid">
                    <div>
                      <label>HS Code</label>
                      <input
                        type="text"
                        placeholder="Enter HS Code"
                        name="hs_code"
                        value={editformik.values.hs_code}
                        onChange={editformik.handleChange}
                      />
                    </div>
                    <div>
                      <label>Transportation Cost</label>
                      <input
                        type="text"
                        placeholder="Enter Transportation Cost"
                        name="retail"
                        value={editformik.values.retail}
                        onChange={editformik.handleChange}
                      />
                    </div>
                  </div>
                  <div className="addModalTextGrid">
                    <div>
                      <label>Additional Notes</label>
                    </div>
                    <div>
                      <textarea
                        placeholder="Type here"
                        rows={4}
                        name="additional_notes"
                        value={editformik.values.additional_notes}
                        onChange={editformik.handleChange}
                      ></textarea>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <button
                    type="button"
                    className="addBtnCancel"
                    onClick={handleEditClose}
                  >
                    Cancel
                  </button>

                  <button className="addBtnSave" type="submit">
                    {" "}
                    Update Changes
                  </button>
                </Modal.Footer>
              </form>
            </Modal>
          </div>

          {/* in stock history edit modal  */}
          <div>
            <Modal
              show={instockeditshow}
              onHide={handleInstockEditClose}
              centered
              className="addModal"
            >
              <Modal.Header closeButton>
                <Modal.Title className="addModalTitle">Edit Stock</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="addModalGrid">
                  <div>
                    <label>Qty Received</label>
                    <input
                      type="text"
                      placeholder="Enter Qty"
                      value={instockQty}
                      onChange={(e) => setInStockQty(e.target.value)}
                    />
                  </div>
                  <div>{""}</div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <button
                  className="addBtnCancel"
                  type="button"
                  onClick={handleInstockEditClose}
                >
                  Cancel
                </button>
                <button className="addBtnSave" onClick={handleInStockEdit}>
                  {" "}
                  Save & Edit Stock
                </button>
              </Modal.Footer>
            </Modal>
          </div>

          {/* delete in stock history modal  */}
          <Modal
            show={deleteStockshow}
            onHide={handleDeleteStockClose}
            centered
            className="paymentModal"
          >
            <Modal.Header closeButton style={{ borderBottom: "none" }}>
              {/* <Modal.Title>Cancel Order</Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
              <div className="cancelOrderTitle">
                Are you sure want to delete stock?
              </div>

              <div className="cancelOrderBtnContainer">
                <div className="paymentBtnCancel">
                  <button onClick={handleDeleteStockClose} type="button">
                    Close
                  </button>
                </div>
                <div className="paymentBtnConfirm">
                  <button onClick={handleDeleteStockIn}>Delete</button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  );
};
